/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteContactMutationResponse,
  DeleteContactPathParams,
} from "../types/DeleteContact.ts"

export const deleteContactMutationKey = () =>
  [{ url: "/v1/contacts/delete-contact/:id" }] as const

export type DeleteContactMutationKey = ReturnType<
  typeof deleteContactMutationKey
>

/**
 * {@link /v1/contacts/delete-contact/:id}
 */
export async function deleteContact(
  id: DeleteContactPathParams["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteContactMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "DELETE",
    url: `/v1/contacts/delete-contact/${id}`,
    ...requestConfig,
  })
  return res
}

export function deleteContactMutationOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = deleteContactMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteContactMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteContactPathParams["id"] },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteContact(id, config)
    },
  })
}

/**
 * {@link /v1/contacts/delete-contact/:id}
 */
export function useDeleteContact<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteContactMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: DeleteContactPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteContactMutationKey()

  const baseOptions = deleteContactMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteContactMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteContactPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteContactMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteContactPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteContactMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteContactPathParams["id"] },
    TContext
  >
}
